/** PURE_IMPORTS_START .._.._Observable,.._.._observable_onErrorResumeNext PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { onErrorResumeNext as staticOnErrorResumeNext } from '../../observable/onErrorResumeNext';
Observable.onErrorResumeNext = staticOnErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map 



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/add/observable/onErrorResumeNext.js
// module id = ./node_modules/rxjs/_esm5/add/observable/onErrorResumeNext.js
// module chunks = vendor